import { createI18n } from "vue-i18n";
import pluralRules from "./rules/pluralization";
import numberFormats from "./rules/numbers";
import datetimeFormats from "./rules/datetime";
// @ts-ignore
import en from "./locales/en.json";
// @ts-ignore
import ro from "./locales/ro.json";

export default createI18n({
    locale: import.meta.env.VITE_DEFAULT_LOCALE, // <--- 1
    fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE, // <--- 2
    legacy: false, // <--- 3
    globalInjection:true,
    messages: {en, ro},
    runtimeOnly: false,
    pluralRules,
    numberFormats,
    // datetimeFormats
})
